const subscriptionHR = {
    "view": {
        "table": {
            "title": "Vaša Pretplata",
            "column": {
                "subscriptionTier": "Razina Pretplate",
                "startDate": "Datum Početka",
                "currentPeriodStart": "Početak Trenutnog Razdoblja",
                "currentPeriodEnd": "Kraj Trenutnog Razdoblja",
                "autoRenewal": "Automatska Obnova",
                "status": "Status",
                "action": "Akcija"
            },
            "label": {
                "status_active": "Aktivna",
                "status_incomplete": "Nepotpuna",
                "status_incomplete_expired": "Nepotpuna Istekla",
                "status_unpaid": "Neplaćena",
                "status_past_due": "Istekla",
                "status_cancelled": "Otkazana",
                "status_expired": "Istekla"
            },
            "actionDropdown": {
                "label": {
                    "action": "Akcija"
                },
                "button": {
                    "enableAutoRenewal": "Omogući Automatsku Obnovu",
                    "upgradeSubscription": "Nadogradi Pretplatu",
                    "cancelSubscription": "Otkaži Pretplatu",
                    "resumeSubscription": "Nastavi Pretplatu",
                    "retryPayment": "Pokušaj Ponovno Plaćanje"
                },
                "message": {
                    "successSubscripionResumed": "Vaša pretplata je nastavljena, vaš račun će uskoro biti ažuriran!",
                    "successSubscripionCancelled": "Vaša pretplata je postavljena da bude otkazana na kraju razdoblja!",
                    "successSubscripionAutoRenewalEnabled": "Vaša pretplata je postavljena da se automatski obnovi na kraju razdoblja!",
                    "activeSubscription": "Već imate aktivnu pretplatu",
                    "incompleteSubscription": "Imate pretplatu koja je nepotpuna."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Otkaži",
                    "enableAutoRenewal": "Omogući automatsku obnovu",
                    "cancelSubscription": "Otkaži pretplatu"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Omogući Automatsku Obnovu",
                "body": "Jeste li sigurni da želite omogućiti automatsku obnovu za svoju pretplatu?"
            },
            "cancel": {
                "header": "Otkaži Pretplatu",
                "body": "Jeste li sigurni da želite otkazati svoju pretplatu?"
            },
            "resume": {
                "header": "Nastavi Pretplatu",
                "body": {
                    "description": "Jeste li sigurni da želite nastaviti pretplatu?",
                    "note": "<strong>Napomena:</strong> Primijenit će se najnovije cijene pretplate!"
                },
                "button": {
                    "cancel": "Otkaži",
                    "resume": "Nastavi"
                },
                "message": {
                    "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
                }
            },
            "retryPayment": {
                "header": "Ponovno Pokušaj Plaćanja Pretplate",
                "body": {
                    "description": "Jeste li sigurni da želite ponovno pokušati plaćanje za pretplatu?",
                    "note": "<strong>Napomena:</strong> Primijenit će se najnovije cijene pretplate!"
                },
                "button": {
                    "cancel": "Otkaži",
                    "retry": "Pokušaj Ponovno"
                },
                "message": {
                    "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Plaćanje pretplate nije uspjelo, molimo pokušajte ponovno kasnije!",
            "errorCardExpired": "Vaša kartica je istekla. Molimo dodajte valjanu zadanu <1>metodu plaćanja</1> i pokušajte ponovno platiti.",
            "errorNoPaymentMethod": "Nemate dodanu nijednu <1>metodu plaćanja</1> na svom profilu. Molimo dodajte valjanu zadanu <3>metodu plaćanja</3> i pokušajte ponovno platiti.",
            "moduleNoAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Odaberite Svoj Plan",
            "button": {
                "startNow": "Započni Sada"
            }
        },
        "message": {
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Nadogradite Svoju Pretplatu",
            "button": {
                "upgrade": "Nadogradi",
                "currentPlan": "Trenutni Plan"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Nadogradnja Pretplate",
                "body": {
                    "description": "Jeste li sigurni da želite nadograditi svoj plan pretplate na <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Napomena: Razdoblje naplate za pretplatu ostat će nepromijenjeno i bit ćete fakturirani samo za iznos isključujući ono što ste već platili za postojeći plan.</strong>"
                },
                "button": {
                    "cancel": "Otkaži",
                    "confirm": "Potvrdi"
                }
            }
        },
        "message": {
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "moduleNoAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    },
    "confirmModal": {
        "header": "Potvrdite Svoje Informacije",
        "body": {
            "form": {
                "label": {
                    "firstName": "Ime",
                    "lastName": "Prezime",
                    "country": "Zemlja Prebivališta",
                    "refundPolicyAgreement": "Nastavkom potvrđujem i prihvaćam da je ovo plaćanje konačno i nepovratno. <1>Pravila o povratu novca</1>",
                },
                "help_text": {
                    "firstName": "Molimo potvrdite da je ovo vaše zakonsko ime.",
                    "lastName": "Molimo potvrdite da je ovo vaše zakonsko prezime.",
                    "country": "Molimo navedite svoju trenutnu zemlju prebivališta."
                },
                "message": {
                    "error": "Došlo je do pogreške prilikom kreiranja pretplate!",
                    "note": "Napomena: Točnost informacija koje ovdje pružite je ključna za sljedeće korake. Osigurajte da su sve informacije točne i istinite."
                }
            }
        },
        "button": {
            "cancel": "Otkaži",
            "confirm": "Potvrdi"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Nadogradnja Pretplate Nije Uspjela :(",
            "description": "Došlo je do problema prilikom nadogradnje vaše pretplate. Molimo pokušajte ponovno kasnije!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu Ploču"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Pretplata Nadograđena :)",
            "description": "Uspješno ste nadogradili svoju pretplatu, vaš račun će uskoro biti ažuriran!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu Ploču"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transakcija Otkazana :(",
            "description": "Transakcija je otkazana... Molimo pokušajte ponovno kasnije!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu Ploču"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transakcija Uspješna :)",
            "description": "Uspješno ste potvrdili svoju pretplatu, vaš račun će uskoro biti nadograđen!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu Ploču"
            }
        }
    }
};

export default subscriptionHR;